import { Component, OnDestroy, OnInit } from '@angular/core';
import { Clipboard } from '@angular/cdk/clipboard';
import { Subscription } from 'rxjs';
import { SupplierApiTesterResult, SupplierApiTesterService } from '../../../supplier-api-tester.service';
import { formatSupplierApiBody, HTTP_METHOD_CLASSES, httpStatusClass } from '../../../supplier-api-tester.models';

interface JournalEntryView extends SupplierApiTesterResult {
  requestText: string;
  responseText: string;
}

/** Journal des appels envoyés à l'API : le dernier est déplié, chacun montre corps envoyé et réponse brute. */
@Component({
  selector: 'vex-api-tester-journal',
  templateUrl: './api-tester-journal.component.html',
  styleUrls: ['../api-tester-shared.scss', './api-tester-journal.component.scss'],
})
export class ApiTesterJournalComponent implements OnInit, OnDestroy {
  readonly methodClasses = HTTP_METHOD_CLASSES;
  readonly httpStatusClass = httpStatusClass;

  entries: JournalEntryView[] = [];
  expandedId: number | null = null;
  copiedId: number | null = null;

  private readonly subscription = new Subscription();

  constructor(
    private readonly supplierApiTesterService: SupplierApiTesterService,
    private readonly clipboard: Clipboard,
  ) {}

  ngOnInit(): void {
    this.subscription.add(
      this.supplierApiTesterService.journal$.subscribe(entries => {
        const latestId = entries[0]?.id ?? null;
        if (latestId !== (this.entries[0]?.id ?? null)) {
          this.expandedId = latestId;
        }
        this.entries = entries.map(entry => ({
          ...entry,
          requestText: formatSupplierApiBody(entry.requestBody),
          responseText: formatSupplierApiBody(entry.body),
        }));
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  toggle(entry: JournalEntryView): void {
    this.expandedId = this.expandedId === entry.id ? null : entry.id;
  }

  copy(entry: JournalEntryView): void {
    this.clipboard.copy(entry.responseText);
    this.copiedId = entry.id;
    setTimeout(() => (this.copiedId = null), 2000);
  }

  clear(): void {
    this.supplierApiTesterService.clearJournal();
  }

  trackById(_: number, entry: JournalEntryView): number {
    return entry.id;
  }
}
